export default "__VITE_ASSET__7bf0a714__"